const assignedViewPrintPackageLabelsAccess = (auth, entity) =>
  auth.access.packages.printLabels.assignedView && entity.hasPrintablePackages;

const packageViewPrintPackageLabelsAccess = auth => auth.access.packages.printLabels.packageView;

export { assignedViewPrintPackageLabelsAccess, packageViewPrintPackageLabelsAccess };
